import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function MinnetonkaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Minnetonka"
      headingExtra="MN"
      introText="Minnetonka travelers — Cargill and UnitedHealth Group executives, Lake Minnetonka families with international summer plans, and west metro residents — have several options for getting a passport fast. Here's how they compare, and why most Minnetonka residents choose a registered State Department courier."
      options={options}
      emergencyDescription="The Chicago Passport Agency at 230 S Dearborn St Suite 380 is approximately 420 miles southeast of Minnetonka — a 6.5+ hour drive via I-94 and I-90. Minnesota has NO passport agency within state borders, meaning all 5.7M+ Minnesotans share exactly zero in-state options. During winter (Nov–April), lake-effect snow squalls and black ice on I-94 turn a 6.5-hour drive into a dangerous multi-day gamble. Cargill and UnitedHealth executives with last-minute international travel cannot rely on a 13-hour winter round-trip to Chicago. With zero passport agencies in Minnesota, a registered courier service is the only practical alternative to a cross-state winter road trip."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. Nearest agency: Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 420 miles southeast of Minnetonka."
    />
  );
}